import { createRootRoute, createRoute, createRouter, redirect } from '@tanstack/react-router';
import { Shell } from './components/Shell';
import { isAuthenticated } from './lib/api';

import { LoginPage } from './pages/Login';
import { OverviewPage } from './pages/Overview';
import { LiveOrdersPage } from './pages/LiveOrders';
import { CartReviewPage } from './pages/CartReview';
import { DispatchPage } from './pages/Dispatch';
import { OrdersPage } from './pages/Orders';
import { StoresPage } from './pages/Stores';
import { CustomersPage } from './pages/Customers';
import { PlatformsPage } from './pages/Platforms';
import { PartnersPage } from './pages/Partners';
import { PaymentsPage } from './pages/Payments';
import { NotificationsPage } from './pages/Notifications';
import { BannersPage } from './pages/Banners';
import { SettingsPage } from './pages/Settings';

const rootRoute = createRootRoute();

const loginRoute = createRoute({ getParentRoute: () => rootRoute, path: '/login', component: LoginPage });

const requireAuth = async () => {
  if (!(await isAuthenticated())) throw redirect({ to: '/login' });
};

const shellRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: 'shell',
  beforeLoad: requireAuth,
  component: Shell,
});

const overviewRoute = createRoute({ getParentRoute: () => shellRoute, path: '/', component: OverviewPage });
const liveOrdersRoute = createRoute({ getParentRoute: () => shellRoute, path: '/orders/live', component: LiveOrdersPage });
const reviewRoute = createRoute({ getParentRoute: () => shellRoute, path: '/review', component: CartReviewPage });
const dispatchRoute = createRoute({ getParentRoute: () => shellRoute, path: '/dispatch', component: DispatchPage });
const ordersRoute = createRoute({ getParentRoute: () => shellRoute, path: '/orders', component: OrdersPage });
const storesRoute = createRoute({ getParentRoute: () => shellRoute, path: '/stores', component: StoresPage });
const customersRoute = createRoute({ getParentRoute: () => shellRoute, path: '/customers', component: CustomersPage });
const platformsRoute = createRoute({ getParentRoute: () => shellRoute, path: '/platforms', component: PlatformsPage });
const partnersRoute = createRoute({ getParentRoute: () => shellRoute, path: '/partners', component: PartnersPage });
const paymentsRoute = createRoute({ getParentRoute: () => shellRoute, path: '/payments', component: PaymentsPage });
const notificationsRoute = createRoute({ getParentRoute: () => shellRoute, path: '/notifications', component: NotificationsPage });
const bannersRoute = createRoute({ getParentRoute: () => shellRoute, path: '/banners', component: BannersPage });
const settingsRoute = createRoute({ getParentRoute: () => shellRoute, path: '/settings/$section', component: SettingsPage });

const routeTree = rootRoute.addChildren([
  loginRoute,
  shellRoute.addChildren([
    overviewRoute,
    liveOrdersRoute,
    reviewRoute,
    dispatchRoute,
    ordersRoute,
    storesRoute,
    customersRoute,
    platformsRoute,
    partnersRoute,
    paymentsRoute,
    notificationsRoute,
    bannersRoute,
    settingsRoute,
  ]),
]);

export const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
